<template>
  <div
    :class="$style.activity"
    :style="{ backgroundColor: commonTempObj.page_background }"
  >
    <!-- 吸顶菜单 -->
    <div
      :class="$style.header"
      :style="{
        backgroundImage: `url('${commonTempObj.navigation_bar_background}')`,
      }"
    >
      <div
        :class="$style.holder"
        :style="{ backgroundImage: `url('${commonTempObj.headline}')` }"
      ></div>
      <ul>
        <li
          v-for="item in anchorList"
          :key="item.id"
          :class="[acId === item.id ? $style.active : '']"
          @click="scrollToEl(item.id)"
        >
          {{ item.text }}
        </li>
      </ul>
    </div>
    <div :class="$style.scrollWrapper" ref="wrapper">
      <div :class="$style.scroll">
        <!-- 游戏下载 -->
        <div :class="$style.download">
          <p v-if="!username">
            <span>你好，请 </span>
            <a @click="$emit('login')">登录</a>
          </p>
          <p v-else>
            <span>你好，{{ username }} </span>
            <a @click="logout">注销</a>
          </p>
          <span :class="$style.contact" @click="showCustomer">联系客服</span>
          <img :src="commonTempObj.page_main_picture_url" alt="" />
          <Button
            :style="{
              backgroundImage: `url('${commonTempObj.theme_button_background}')`,
            }"
            :class="$style.downloadBtn"
            @click="openDownloadLink"
            >开始游戏</Button
          >
        </div>
        <div v-for="(item, index) in activityList" :key="index">
          <!-- 老玩家召回 -->
          <div
            v-if="item.activityType && item.activityType === 'RecalledRecall'"
            :class="$style.regression"
            :id="`RecalledRecall-${index}`"
          >
            <div
              :style="{
                backgroundImage: `url('${commonTempObj.subtitle_background}')`,
              }"
              :class="$style.title"
            >
              {{ item.subtitle }}
            </div>
            <pre
              :class="$style.hint"
              v-if="!isReturn"
              v-html="item.description"
            ></pre>
            <p :class="$style.hint" v-else style="text-align: center">
              恭喜您，您已成功回归！
            </p>
            <div
              :style="{ backgroundColor: commonTempObj.activity_background }"
              :class="$style.way"
            >
              <span :class="$style.backline"></span>
              <div :class="$style.content">
                <!-- <p>1、填写好友的召回口令，您和您的好友都可以获得{{commonTempObj.credit_style}}奖励</p> -->
                <p v-html="item.config.ruleDescription"></p>
                <div :class="$style.passive">
                  <input type="text" v-model="command" />
                  <!-- 确认回归 -->
                  <div
                    :style="{
                      backgroundColor: !!isReturn
                        ? grayColor
                        : commonTempObj.normal_button_background,
                    }"
                    :class="$style.btn"
                    @click="summon(0)"
                  >
                    确认回归
                  </div>
                </div>
                <!-- <p>
                  2、自主回归，选择自主回归，您可以获得同样的{{commonTempObj.credit_style}}奖励，但是您的朋友不会获得奖励。
                </p> -->
                <!-- 确认自主回归 -->
                <div
                  :style="{
                    backgroundColor: !!isReturn
                      ? grayColor
                      : commonTempObj.normal_button_background,
                  }"
                  :class="[$style.btn, $style.sureBtn]"
                  @click="summon(1)"
                >
                  确认自主回归
                </div>
              </div>
            </div>
          </div>
          <!-- 被召回者页面显示，回归奖励 -->
          <div
            v-if="item.activityType && item.activityType === 'RecalledJoinGift'"
            :class="$style.award"
            :id="`RecalledJoinGift-${index}`"
          >
            <div
              :style="{
                backgroundImage: `url('${commonTempObj.subtitle_background}')`,
              }"
              :class="$style.title"
            >
              {{ item.subtitle }}
            </div>
            <pre v-html="item.description"></pre>
            <div :class="$style.propsList">
              <div
                v-for="(m, i) in item.config.gifts"
                :key="i"
                :style="{ backgroundImage: `url('${cdnUrl}/gift_bg.png')` }"
              >
                <p>{{ m.giftName }}</p>
                <img :src="m.iconUrl" alt="" />
              </div>
            </div>
            <Button
              :style="{
                backgroundImage: `url('${commonTempObj.theme_button_background}')`,
              }"
              :class="$style.receiveAward"
              @click="receiveAward"
              >点击领取</Button
            >
            <!-- <img :src="commonTempObj.subtitle_background" alt="" :class="$style.title" id="_award2" /> -->
          </div>
          <!-- 被召回者页面显示，回归线上福利 -->
          <div
            v-if="item.activityType && item.activityType === 'RecalledDetail'"
            :class="$style.award2"
            :id="`RecalledDetail-${index}`"
          >
            <div
              :style="{
                backgroundImage: `url('${commonTempObj.subtitle_background}')`,
              }"
              :class="$style.title"
            >
              {{ item.subtitle }}
            </div>
            <!-- <img :src="`${cdnUrl}/big_title_2.png`" alt="" :class="$style.title" id="_award2" /> -->
            <pre v-html="item.description"></pre>
            <div :class="$style.acBanner">
              <span :class="$style.backline"></span>
              <img :src="item.config.pictureUrl" alt="" />
            </div>
            <Button
              :style="{
                backgroundImage: `url('${commonTempObj.theme_button_background}')`,
              }"
              :class="$style.learnMore"
              @click="openDownloadLink"
              >立即了解详情</Button
            >
          </div>
          <!-- 召回老朋友 -->
          <div
            v-if="item.activityType && item.activityType === 'RecallerRecall'"
            :class="$style.regression"
            :id="`RecallerRecall-${index}`"
          >
            <div
              :style="{
                backgroundImage: `url('${commonTempObj.subtitle_background}')`,
              }"
              :class="$style.title"
            >
              {{ item.subtitle }}
            </div>
            <pre :class="$style.hint" v-html="item.description"></pre>
            <div
              :style="{ backgroundColor: commonTempObj.activity_background }"
              :class="$style.way"
            >
              <span :class="$style.backline"></span>
              <div :class="$style.copyContent">
                <p v-html="item.config.ruleDescription"></p>
                <div :class="$style.passive">
                  <span>{{ summon_word }}</span>
                  <!-- 复制 -->
                  <!-- <button :class="[$style.btn, 'copyBtn']" :data-clipboard-text="summon_word">复制</button> -->
                  <button
                    v-if="!username"
                    @click="$emit('login')"
                    :style="{
                      backgroundColor: commonTempObj.normal_button_background,
                    }"
                    :class="[$style.btn, 'copyBtn']"
                  >
                    复制
                  </button>
                  <button
                    v-if="username"
                    :style="{
                      backgroundColor: commonTempObj.normal_button_background,
                    }"
                    :class="[$style.btn, 'copyBtn']"
                    :data-clipboard-text="
                      item.config.copyContent === 2
                        ? `口令：${summon_word}，地址：${href}`
                        : summon_word
                    "
                  >
                    复制
                  </button>
                </div>
                <!-- <Button :class="$style.getSummonWord" @click="getUserSummonWord"></Button> -->
                <!-- <div :style="{backgroundColor: commonTempObj.normal_button_background}" :class="[$style.getSummonWord, $style.btn]" @click="getUserSummonWord">生成召唤口令</div> -->
                <!-- 已召回列表 -->
                <div
                  :class="$style.recallList"
                  v-show="boundUserList && boundUserList.length"
                >
                  <h1>您召回的小伙伴</h1>
                  <p v-for="(item, index) in boundUserList" :key="index">
                    {{ item }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- 货币领取 -->
          <div
            v-if="item.activityType && item.activityType === 'GainCredit'"
            :class="$style.receiveMB"
            :id="`GainCredit-${index}`"
          >
            <div
              :style="{
                backgroundImage: `url('${commonTempObj.subtitle_background}')`,
              }"
              :class="$style.title"
            >
              {{ item.subtitle }}
            </div>
            <div :class="$style.wowb" v-show="username" @click="refreshMb">
              <i
                :class="`iconfont yw-shuaxin1 ${
                  refreshState && $style.refreshStateActive
                }`"
              ></i>
              <span>已有{{ commonTempObj.credit_style }}:{{ coin }}</span>
            </div>
            <pre v-html="item.description"></pre>
            <p>如有疑问请<a @click="showCustomer">咨询客服</a></p>
            <!-- 回归登录 -->
            <div
              :style="{ backgroundColor: commonTempObj.activity_background }"
              :class="$style.receiveContent"
            >
              <span :class="$style.backline"></span>
              <div>
                <!-- <img :src="`${cdnUrl}/title_1.png`" alt="" :class="$style.titleWord" /> -->
                <p :class="$style.titleWord">
                  {{ item.config.activeLoginName }}
                </p>
                <ul :class="$style.receiveItem">
                  <li
                    v-for="(m, index) in MBInfo.login"
                    :class="chooseIndex(index) && $style.holder"
                    :key="m.id"
                    @click="getCoin(m.id, m.status, 1)"
                  >
                    <p>{{ `第${m.typeValue}天` }}</p>
                    <img
                      :src="`${cdnUrl}/login_${
                        chooseIndex(index) ? '2' : '1'
                      }.png`"
                      alt=""
                    />
                    <span :class="$style.num">{{
                      commonTempObj.credit_style + m.gainCoin
                    }}</span>
                    <span
                      :class="[
                        $style.state,
                        m.status === 1 ? $style.active : '',
                      ]"
                      >{{ judgeState(m.status) }}</span
                    >
                  </li>
                </ul>
              </div>
            </div>
            <!-- 回归充值 -->
            <div
              :style="{ backgroundColor: commonTempObj.activity_background }"
              :class="$style.regressionCharge"
            >
              <span :class="$style.backline"></span>
              <div>
                <!-- <img :src="`${cdnUrl}/title_2.png`" alt="" :class="$style.titleWord" /> -->
                <p :class="$style.titleWord">{{ item.config.activePayName }}</p>
                <ul :class="$style.receiveItem">
                  <li>
                    <span>充值</span>
                    <span>可获{{ commonTempObj.credit_style }}</span>
                    <span>领取状态</span>
                  </li>
                  <li v-for="(m, i) in MBInfo.pay" :key="m.id">
                    <span>{{ i === 0 ? "首充" : m.typeValue }}</span>
                    <span>{{ m.gainCoin }}</span>
                    <span>
                      <Button
                        :class="[
                          $style.state,
                          m.status === 1 ? $style.active : '',
                        ]"
                        @click="getCoin(m.id, m.status, 2)"
                        >{{ judgeState(m.status) }}</Button
                      >
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 货币抽奖 -->
          <div
            v-if="item.activityType && item.activityType === 'Turntable'"
            :class="$style.lottery"
            :id="`Turntable-${index}`"
          >
            <div
              :style="{
                backgroundImage: `url('${commonTempObj.subtitle_background}')`,
              }"
              :class="$style.title"
            >
              {{ item.subtitle }}
            </div>
            <img
              :src="`${cdnUrl}/wenhao.png`"
              alt=""
              :class="$style.wenhao"
              @click="recordShow = true"
            />
            <pre v-html="item.description"></pre>
            <!-- <p>活动时间：<span :class="$style.lighter">{{ `${changeTimeStr(commonTempObj.activity_start_date)}-${changeTimeStr(commonTempObj.receive_gift_end_date)}`  }}</span></p>
            <p>参与范围：<span :class="$style.lighter">每消耗{{item.config.use_integral + commonTempObj.credit_style}}可参与抽奖1次，每日最多抽奖{{item.config.max_use}}次</span></p> -->
            <p :class="$style.record" @click="showWinning(item.activityId)">
              中奖记录
            </p>
            <Lottery
              :coinname="commonTempObj.credit_style"
              :config="item.config"
              :activityid="item.activityId"
              @login="$emit('login')"
              @showDialog="showDialog"
            />
          </div>
          <!-- 红包大放送 -->
          <div
            v-if="item.activityType && item.activityType === 'CreditRedPacket'"
            :class="$style.redPacket"
            :id="`CreditRedPacket-${index}`"
          >
            <div
              :style="{
                backgroundImage: `url('${commonTempObj.subtitle_background}')`,
              }"
              :class="$style.title"
            >
              {{ item.subtitle }}
            </div>
            <!-- <p>活动时间：<span :class="$style.lighter">{{ `${changeTimeStr(commonTempObj.activity_start_date)}-${changeTimeStr(commonTempObj.receive_gift_end_date)}`  }}</span></p>
            <p>参与范围：<span :class="$style.lighter">所有在本页面参与的玩家</span></p>
            <p>参与方式：<span :class="$style.lighter">玩家通过页面活动获得{{commonTempObj.credit_style}}，当获得的{{commonTempObj.credit_style}}达到一定值，可以获得专属红包奖励，每个档位只能领取一次</span></p>
            <p>当{{commonTempObj.credit_style}}值满足领取条件时，下方的红包会<span :class="$style.lighter">显示红色，点击红包 即可领取奖励</span></p> -->
            <pre v-html="item.description"></pre>
            <div
              :style="{ backgroundColor: commonTempObj.activity_background }"
              :class="$style.getRedPacket"
            >
              <span :class="$style.backline"></span>
              <ul>
                <li v-for="(m, index) in redPacketModal" :key="index">
                  <img
                    :src="`${cdnUrl}/red_${m.status === 0 ? 3 : m.status}.png`"
                    alt=""
                    @click="getRedPacket(m, item.activityId)"
                  />
                  <div
                    :class="[
                      $style.introduce,
                      index % 2 === 0 ? $style.right : '',
                    ]"
                  >
                    {{
                      m.packetType === 2
                        ? `${commonTempObj.credit_style}获取`
                        : "累计充值"
                    }}{{ m.relation === 1 ? "大于" : "达到"
                    }}<span :class="$style.lighter">{{ m.thresholdValue }}</span
                    >的玩家可获得<span :class="$style.lighter">{{
                      m.giftName
                    }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 回归豪礼弹窗 -->
    <RegressionCode
      v-if="regressionCodeShow"
      @close="regressionCodeShow = false"
    ></RegressionCode>
    <!-- 中奖记录 -->
    <Winning
      ref="winning"
      v-if="winningShow"
      :activityId="activityId"
      @close="winningShow = false"
      @showDialog="showDialog"
      @openDownloadLink="openDownloadLink"
    ></Winning>
    <!-- 通用弹框 -->
    <Dialog
      v-if="dialogShow"
      @freshRecord="freshRecord"
      @close="dialogShow = false"
      :giftData="giftData"
      @openDownloadLink="openDownloadLink"
    ></Dialog>
    <!-- 概率公示 -->
    <Record
      v-if="recordShow"
      :recordList="recordList"
      @close="recordShow = false"
    ></Record>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import MouseWheel from "@better-scroll/mouse-wheel";
import Clipboard from "clipboard";
import Lottery from "./Lottery";
import RegressionCode from "./RegressionCode";
import Winning from "./Winning";
import Dialog from "./Dialog";
import Record from "./Record";
import { Button, Toast, Dialog as Dlog } from "vant";
import { mapState, mapActions, mapMutations } from "vuex";
import {
  bindingCode,
  getCoin,
  addRecord,
  commonTemplate,
  commonActivities,
  commonActivitiesLogin,
} from "@/apis/recall";

BScroll.use(MouseWheel);

const LOTTERY_DATE = "2021年2月8日-2021年2月17日";
const REGRESSION = ["2021年2月1日", "2021年2月1日至2021年2月7日", "500"];

export default {
  name: "",
  data() {
    return {
      cdnUrl: "//static.hzwxbz3.cn/Lianyun/font_end/ac",
      command: "",
      receiveList: [],
      LOTTERY_DATE,
      REGRESSION,
      regressionCodeShow: false,
      winningShow: false,
      dialogShow: false,
      recordShow: false,
      acId: "",
      giftData: {},
      summonFlag: false,
      refreshState: false,
      commonTempObj: {
        activity_background: "",
        credit_style: "",
        game_url: "",
        navigation_bar_background: "",
        normal_button_background: "",
        page_background: "",
        subtitle_background: "",
        template_name: "",
        theme_button_background: "",
      },
      grayColor: "#a4a4a4",
      activityList: [],
      href: "",
      anchorList: [],
      recordList: [],
      activityId: 0,
      coinFlag: true,
      refreshMbFlag: true,
    };
  },
  mounted() {
    this.href = window.location.href;
    setTimeout(() => {
      this.copyInit();
      this.scrollInit();
      this.getCommonTemplate();
      this.getCommonActivities();
      this.getRedPacketList();
    }, 500);
  },
  computed: {
    ...mapState({
      username: (state) => state.recall.user_name,
      userType: (state) => state.recall.user_type,
      MBInfo: (state) => state.recall.MBInfo,
      redPacketModal: (state) => state.recall.redPacketModal,
      summon_word: (state) => state.recall.summon_word,
      boundUserList: (state) => state.recall.boundUserList,
      isReturn: (state) => state.recall.is_return,
      coin: (state) => state.recall.coin,
      template_id: (state) => state.recall.template_id,
      loginType: (state) => state.recall.loginType,
    }),
    propsList() {
      return [
        `${this.cdnUrl}/gift_1.png`,
        `${this.cdnUrl}/gift_2.png`,
        `${this.cdnUrl}/gift_3.png`,
        `${this.cdnUrl}/gift_4.png`,
        `${this.cdnUrl}/gift_5.png`,
      ];
    },
  },
  watch: {
    username() {
      this.summonFlag = false;
    },
    MBInfo() {
      setTimeout(() => {
        this.refreshScroll();
      }, 500);
    },
    boundUserList() {
      setTimeout(() => {
        this.refreshScroll();
      }, 500);
    },
    userType() {
      setTimeout(() => {
        this.refreshScroll();
      }, 500);
    },
    activityList() {
      setTimeout(() => {
        this.refreshScroll();
      }, 500);
    },
  },
  methods: {
    ...mapMutations({
      setRecallState: "recall/CHANGE_RECALL_STATE",
    }),
    ...mapActions({
      getSummonWord: "recall/getSummonWord",
      getLoginMBList: "recall/getLoginMBList",
      getUserInfo: "recall/getUserInfo",
      showCustomer: "recall/showCustomer",
      resetTemp: "recall/resetTemp",
      getRedPacketList: "recall/getRedPacketList",
    }),
    // 获取基础模板信息
    async getCommonTemplate() {
      const id = localStorage.getItem("tempId");
      if (!id) return;
      const r = await commonTemplate(id);
      if (r.ret !== 1) return;
      this.commonTempObj = r.content;
    },
    // 获取模板活动信息
    async getCommonActivities() {
      const id = localStorage.getItem("tempId");
      if (!id) return;
      const r = !this.username
        ? await commonActivities(id)
        : await commonActivitiesLogin(id);
      if (r.ret !== 1) return;
      this.activityList = r.content.activity_list.sort(
        (a, b) => a.sort - b.sort
      );
      this.anchorList = this.activityList.map((m, i) => {
        if (m.activityType === "Turntable") {
          this.recordList = m.config.turntables.map((item) => {
            return {
              award: item.giftName,
              probability: item.showProbability,
            };
          });
        }
        return {
          id: `${m.activityType}-${i}`,
          text: m.subtitle,
        };
      });
    },
    // 替换时间字符
    changeTimeStr(str) {
      const arr = str.split("-");
      return `${arr[0]}年${arr[1]}月${arr[2]}日`;
    },
    chooseIndex(index) {
      const i = (index + 1) % 7;
      return i === 5 || i === 6 || i === 0;
    },
    refreshScroll() {
      this.scroller && this.scroller.refresh();
    },
    copyInit() {
      this.copy = new Clipboard(".copyBtn");
      this.copy.on("success", () => {
        Toast("复制成功");
      });
    },
    scrollToEl(id) {
      this.acId = id;
      this.scroller.scrollToElement(`#${id}`, 500, 0, -50);
    },
    scrollInit() {
      this.scroller = new BScroll(this.$refs.wrapper, {
        click: true,
        mouseWheel: {
          speed: 20,
          invert: false,
          easeTime: 300,
        },
        autoBlur: false,
        bounce: {
          top: false,
          bottom: true,
        },
      });
    },
    openDownloadLink() {
      window.open(this.commonTempObj.game_url, "_blank");
    },
    async receiveAward() {
      if (!this.username) {
        this.$emit("login");
        return;
      }
      try {
        this.regressionCodeShow = true;
      } catch (error) {
        console.log(error);
      }
    },
    learnMore() {
      window.open(
        "https://wpa1.qq.com/Q2eB66Xo?_type=wpa&qidian=true",
        "_blank"
      );
    },
    judgeState(state) {
      switch (state) {
        case 0:
          return "不可领取";
        case 1:
          return "可领取";
        case 2:
          return "已领取";
      }
    },
    logout() {
      this.resetTemp();
      this.getCommonTemplate();
      this.getCommonActivities();
    },
    showWinning(actId) {
      if (!this.username) {
        this.$emit("login");
        return;
      }
      this.winningShow = true;
      this.activityId = actId;
    },
    freshRecord() {
      this.$refs.winning && this.$refs.winning.getRecord();
    },
    showDialog(giftData) {
      this.giftData = Object.assign(
        { type: 2, id: giftData.record_id },
        giftData
      );
      this.getUserInfo();
      this.dialogShow = true;
    },
    refreshMb() {
      if (!this.refreshMbFlag) {
        Toast("您刷新的太快啦，请稍后重试~");
        return;
      }
      this.refreshMbFlag = false;
      setTimeout(() => {
        this.refreshMbFlag = true;
      }, 5000);
      this.refreshState = true;
      this.getUserInfo(() => {
        setTimeout(() => {
          // 让动画多转一会
          this.refreshState = false;
        }, 1000);
      });
    },
    async summon(type) {
      if (!this.username) {
        this.$emit("login");
        return;
      }
      if (this.summonFlag) return;

      if (this.isReturn) {
        Toast.fail("您已经回归过啦~");
        return;
      }

      if (!type) {
        if (!this.command) {
          Toast("请输入口令");
          return;
        }
        this.bindCode();
      } else {
        // 自主回归
        if (this.command) {
          Dlog.confirm({
            message: "您当前已输入召回码，确认选择自主回归？",
            "confirm-button-text": "是",
            "cancel-button-text": "否",
          })
            .then(async () => {
              this.bindCode(1);
            })
            .catch(async () => {});
        } else {
          this.bindCode(1);
        }
      }
    },
    async bindCode(type) {
      try {
        if (!type) {
          await bindingCode({
            recall_code: this.command,
            template_id: this.template_id,
            login_type: this.loginType,
          });
        } else {
          await bindingCode({
            template_id: this.template_id,
            login_type: this.loginType,
          });
        }
        Toast("确认回归成功");
        this.summonFlag = true;
        this.command = "";
        this.getLoginMBList();
        this.getUserInfo();
      } catch (error) {
        if (error.ret === 586) this.summonFlag = true;
      }
    },
    async getCoin(id, status, type) {
      if (!this.username) {
        this.$emit("login");
        return;
      }
      if (status !== 1) return;
      if (!this.coinFlag) return;
      this.coinFlag = false;
      setTimeout(() => {
        this.coinFlag = true;
      }, 2000);
      await getCoin({
        activity_type: type,
        index: id,
        template_id: this.template_id,
      });
      Toast.success("领取成功");
      // this.getLoginMBList();
      this.getUserInfo();
    },
    async getRedPacket(item, actId) {
      if (item.status === 0) return;
      // 领取红包
      const r = await addRecord({
        index: item.id,
        template_id: this.template_id,
      });
      if (r.ret !== 1) return;
      console.log(actId);
      this.giftData = {
        activityId: actId,
        type: 1,
        id: item.id,
        ...r.content,
      };
      this.dialogShow = true;
      this.getRedPacketList();
    },
  },
  components: {
    Button,
    Lottery,
    RegressionCode,
    Winning,
    Dialog,
    Record,
  },
};
</script>

<style lang="scss" module>
%btn {
  display: block;
  margin: auto;
  width: 150px;
  border: none;
  height: 45px;
  font-size: 22px;
  font-family: MicrosoftYaHei;
  font-weight: bolder;
  color: #573f19;
}
%borderLayout {
  position: relative;
  &::before {
    position: absolute;
    content: " ";
    top: -11px;
    left: -2%;
    width: 104%;
    height: 20px;
    background-image: url("#{$cdn-url-recall}/di_1.png?v=1");
    background-size: 100% 100%;
    z-index: 1;
  }
  &::after {
    position: absolute;
    content: " ";
    bottom: -7px;
    left: -2%;
    width: 104%;
    height: 20px;
    background-image: url("#{$cdn-url-recall}/di_3.png?v=1");
    background-size: 100% 100%;
    z-index: 1;
  }
  .backline {
    position: absolute;
    width: 104%;
    left: -2%;
    top: 9px;
    bottom: 13px;
    background: url("#{$cdn-url-recall}/di_2.png?v=1");
    background-size: 100% 100%;
  }
}
%borderBox {
  padding: 0px 10px;
  // border: 1px solid #beac98;
  box-shadow: 0 -1px 1px -0.1px rgb(190, 172, 152, 0.5),
    //上边线
    1px 0 1px -0.1px rgb(190, 172, 152, 0.5),
    //右边线
    0 1px 1px -0.1px rgb(190, 172, 152, 0.5),
    //下边线
    -1px 0 1px -0.1px rgb(190, 172, 152, 0.5); //左边线
}
.lighter {
  color: #ebd3a1;
}
.title {
  // display: block;
  width: 84%;
  height: 60px;
  // display: inline-block;
  margin: 0px auto 12px auto;
  background-repeat: no-repeat;
  background-size: 100%;
  font-size: 22px;
  font-family: FZXBSJW;
  font-weight: normal;
  color: #f0c285;
  line-height: 45px;
}

.activity {
  height: 100%;
  font-size: 13px;
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    text-align: left;
    height: auto;
    color: #9a6545;
  }
  .scrollWrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .scroll {
      padding-bottom: 40px;
    }
  }
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: rgba(0, 0, 0, 0.5);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    z-index: 1;
    .holder {
      width: 105px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    > ul {
      width: 270px;
      display: flex;
      overflow-x: auto;
      > li {
        min-width: 60px;
        text-align: center;
        color: #ffc76e;
        flex: none;
        padding: 0 10px;
        line-height: 50px;
        &:active {
          opacity: 0.9;
        }
      }
    }
  }
  .download {
    position: relative;
    > img {
      width: 100%;
    }
    > p {
      position: absolute;
      top: 60px;
      left: 10px;
      color: #ffffff;
      font-size: 13px;
      > a {
        color: #ead7a5;
      }
    }
    .contact {
      position: absolute;
      top: 60px;
      right: 10px;
      color: #ead7a5;
    }
    .downloadBtn {
      @extend %btn;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .award {
    padding-top: 55px;
    text-align: center;
    > pre {
      line-height: 1.4;
      color: #9a6545;
      text-align: left;
      margin: 7px;
    }
    .propsList {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      > div {
        width: 106px;
        height: 133px;
        margin: 5px 7px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
        padding-top: 10px;
        > img {
          width: 60px;
          position: absolute;
          left: 22px;
          bottom: 24px;
        }
        > p {
          width: 100%;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          line-height: 25px;
          color: #e9d09f;
        }
      }
    }
    .receiveAward {
      @extend %btn;
      margin-top: 23px;
      margin-bottom: 25px;
      // background: url("#{$cdn-url-recall}/button_2.png") no-repeat;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .award2 {
    padding-top: 55px;
    text-align: center;
    > pre {
      line-height: 1.4;
      color: #9a6545;
      text-align: left;
      margin: 7px;
    }
    .acBanner {
      @extend %borderBox;
      padding: 0px;
      width: 92%;
      display: inline-block;
      margin-top: 13px;
      > img {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 2;
      }
    }
    .learnMore {
      @extend %btn;
      width: 180px;
      margin-top: 23px;
      background: url("#{$cdn-url-recall}/button_3.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .regression {
    padding-top: 25px;
    text-align: center;
    color: #9a6545;
    .hint {
      text-align: left;
      line-height: 1.5;
      margin: 7px;
      margin-bottom: 15px;
    }
    .way {
      // @extend %borderLayout;
      @extend %borderBox;
      width: 92%;
      margin: auto;
      .content {
        position: relative;
        z-index: 2;
        text-align: left;
        padding: 20px 0 12px;
        > p {
          margin-bottom: 15px;
          line-height: 1.5;
        }
        .btn {
          // background: url("#{$cdn-url-recall}/regress_1.png") no-repeat;
          background-size: 100% 100%;
          width: 71px;
          height: 28px;
          border: none;
          margin-left: 5px;
          text-align: center;
          line-height: 28px;
          border-radius: 8px;
          // &.black {
          //   background: url("#{$cdn-url-recall}/regress_1_black.png") no-repeat;
          //   background-size: 100% 100%;
          // }
        }
        .sureBtn {
          width: 100px;
          margin: 0 auto;
        }
        .passive {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 18px;
          > input {
            width: 215px;
            height: 31px;
            color: #000000;
          }
        }
        > button {
          @extend %btn;
          width: 106px;
          height: 35px;
          background: url("#{$cdn-url-recall}/regress_2.png") no-repeat;
          background-size: 100% 100%;
          &.black {
            background: url("#{$cdn-url-recall}/regress_2_black.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    .copyContent {
      position: relative;
      z-index: 2;
      text-align: left;
      padding: 10px 0 12px;
      > p {
        line-height: 1.2;
        color: #ebd2a1;
      }
      .passive {
        background: #ffffff;
        padding: 9px 15px;
        color: #000000;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 12px;
      }
      .btn {
        color: #9a6545;
        // background: url("#{$cdn-url-recall}/regress_1.png") no-repeat;
        background-size: 100% 100%;
        width: 71px;
        height: 28px;
        border: none;
        margin-left: 5px;
        text-align: center;
        line-height: 28px;
        border-radius: 8px;
        // &.black {
        //   background: url("#{$cdn-url-recall}/regress_1_black.png") no-repeat;
        //   background-size: 100% 100%;
        // }
      }
      .sureBtn {
        width: 100px;
        margin: 0 auto;
      }
      .getSummonWord {
        width: 106px;
        height: 35px;
        line-height: 35px;
        // background: url("#{$cdn-url-recall}/regress_3.png") no-repeat;
        // background-size: 100% 100%;
        // border: none;
        // display: block;
        margin: auto;
      }
      .recallList {
        width: 98%;
        padding: 15px;
        text-align: center;
        line-height: 1.5;
        background: url("#{$cdn-url-recall}/regress_di_1.png") no-repeat;
        background-size: 100% 100%;
        margin: auto;
        margin-top: 15px;
        > h1 {
          color: #000000;
        }
        > p {
          color: #632f10;
        }
      }
    }
  }
  .receiveMB {
    text-align: center;
    padding-top: 25px;
    position: relative;
    > pre,
    > p {
      line-height: 1.4;
      color: #9a6545;
      text-align: left;
      margin: 7px;
      > a {
        color: #ebd2a1;
        text-decoration: underline;
      }
    }
    .wowb {
      position: absolute;
      top: 60px;
      right: 10px;
      color: #ffffff;
      font-size: 12px;
      .refreshStateActive {
        transform: rotate(360deg);
        transition: all 1000ms ease-in;
      }
      :global {
        .yw-shuaxin1 {
          display: inline-block;
          font-size: 12px;
          margin-right: 3px;
        }
      }
    }
    .receiveContent {
      // @extend %borderLayout;
      @extend %borderBox;
      width: 92%;
      display: inline-block;
      margin-top: 13px;
      > div {
        position: relative;
        z-index: 2;
      }
      .titleWord {
        width: 30%;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #e4c995;
        margin: 10px auto 15px auto;
        line-height: 20px;
      }
      .receiveItem {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding-bottom: 10px;
        .holder {
          margin: 5px;
        }
        > li {
          width: 79px;
          height: 79px;
          color: #ffffff;
          position: relative;
          > p {
            width: 100%;
            text-align: center;
            font-size: 8px;
            line-height: 13px;
            position: absolute;
            top: 9px;
          }
          > img {
            width: 100%;
            height: 100%;
          }
          .num {
            position: absolute;
            bottom: 22px;
            left: 0;
            right: 0;
            font-size: 8px;
          }
          .state {
            background: url("#{$cdn-url-recall}/miao_2.png") no-repeat;
            background-size: 100% 100%;
            width: 49px;
            height: 13px;
            display: inline-block;
            font-size: 8px;
            line-height: 13px;
            position: absolute;
            bottom: 8px;
            left: 0;
            right: 0;
            margin: auto;
            &.active {
              background: url("#{$cdn-url-recall}/miao_1.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
    .regressionCharge {
      // @extend %borderLayout;
      @extend %borderBox;
      width: 92%;
      display: inline-block;
      margin-top: 26px;
      padding-bottom: 15px;
      > div {
        position: relative;
        z-index: 2;
      }
      .titleWord {
        width: 30%;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #e4c995;
        margin: 10px auto 15px auto;
        line-height: 20px;
      }
      .receiveItem {
        display: block;
        > li {
          display: flex;
          width: 80%;
          margin: auto;
          justify-content: space-evenly;
          text-align: center;
          > span {
            width: 33.3%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px 0;
            background: #f4ddc0;
            border-bottom: 1px solid #cc9f6c;
          }
          .state {
            @extend %btn;
            background: url("#{$cdn-url-recall}/receive_2.png") no-repeat;
            background-size: 100% 100%;
            display: inline-block;
            font-size: 8px;
            width: 67px;
            height: 21px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #494949;
            line-height: 1;
            &.active {
              background: url("#{$cdn-url-recall}/receive_1.png") no-repeat;
              background-size: 100% 100%;
              color: #684216;
            }
          }
        }
        > li:nth-child(1) {
          > span {
            display: inline-block;
            background-color: #6f1710;
            color: #f7dfaf;
            padding: 8px 0;
          }
        }
      }
    }
  }
  .lottery {
    text-align: center;
    color: #794a35;
    margin-top: 25px;
    position: relative;
    > pre,
    > p {
      line-height: 26px;
      padding: 0px 10px;
      margin-bottom: 30px;
    }
    .wenhao {
      position: absolute;
      top: 16px;
      left: 122px;
      right: 0;
      margin: auto;
      width: 15px;
      height: 15px;
    }
    .record {
      position: absolute;
      width: 100px;
      top: 130px;
      right: 17px;
      text-align: right;
      color: #ffffff;
      text-decoration: underline;
      font-size: 11px;
      // background-color: pink;
    }
  }
  .redPacket {
    text-align: center;
    padding: 42px 10px 0 10px;
    color: #794a35;
    line-height: 20px;
    .getRedPacket {
      // @extend %borderLayout;
      @extend %borderBox;
      width: 92%;
      display: inline-block;
      margin-top: 26px;
      padding-bottom: 15px;
      > ul {
        position: relative;
        z-index: 2;
        > li {
          position: relative;
          height: 90px;
          padding: 20px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 26px;
            height: 34px;
          }
          .introduce {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            right: 170px;
            margin: auto;
            width: 143px;
            height: auto;
            display: inline-block;
            // height: 58px;
            background: url("#{$cdn-url-recall}/red_di_1.png") no-repeat;
            background-size: 100% 100%;
            padding: 10px;
            font-size: 11px;
            color: #e9d09f;
            text-align: left;
            &.right {
              left: 170px;
              right: 0;
              background: url("#{$cdn-url-recall}/red_di_2.png") no-repeat;
              background-size: 100% 100%;
            }
            .lighter {
              color: #fbf6e7;
            }
          }
        }
        &:before {
          position: absolute;
          content: " ";
          width: 8px;
          background: #41241d;
          left: 0;
          right: 0;
          top: 30px;
          bottom: 30px;
          margin: auto;
        }
      }
    }
  }
}
</style>